// extracted by mini-css-extract-plugin
export default {"external":"aT83kk","asset":"bT83kk"};